import React, { useState, useEffect, useCallback } from "react";
import styles from "./MenuModal.module.css";
import { Icon } from "@iconify/react";
import { menuTabs } from "./menuTabs";

export default function MenuModal({ onClose, initialTab = "account" }) {
  const [active, setActive] = useState(initialTab);

  const handleKey = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
    },
    [onClose],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [handleKey]);

  useEffect(() => {
    // Update active tab when initialTab prop changes
    setActive(initialTab);
  }, [initialTab]);

  const ActiveComp =
    menuTabs.find((t) => t.id === active)?.component || (() => null);

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div
        className={styles.modal}
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={styles.left}>
          <div className={styles.logoArea}></div>
          <ul className={styles.tabList}>
            {menuTabs.map((tab) => (
              <li key={tab.id}>
                <button
                  className={`${styles.tabBtn} ${
                    tab.id === active ? styles.active : ""
                  }`}
                  onClick={() => setActive(tab.id)}
                >
                  <Icon icon={tab.icon} className={styles.tabIcon} />
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.right}>
          <div className={styles.header}>
            <h3>{menuTabs.find((t) => t.id === active)?.label || "เมนู"}</h3>
            <button className={styles.close} onClick={onClose}>
              ✕
            </button>
          </div>
          <div className={styles.content}>
            <ActiveComp />
          </div>
        </div>
      </div>
    </div>
  );
}
